let state = {
  layout: null,
  lastCaseQuery: "",
  lastLawQuery: "",
  lastNotesQuery: "",
  lastDigestsQuery: "",
  showBackButton: false,
  moreHeaderButtons: {mobile: [], web: []},
  showClearHighlights: false,
  showSpinner: false,
  header: {
    title: ""
  },
  menu: [
    {
      name: "home",
      title: "Dashboard",
      icon: "speedometer",
      route: "/dashboard",
      emit: null
    },
    {
      name: "cases",
      title: "Cases",
      icon: "briefcase",
      route: "/cases",
      emit: null,
      photo: "img/icon_cases.png"
    },
    {
      name: "laws",
      title: "Laws",
      icon: "paper",
      route: "/laws",
      emit: null,
      photo: "img/icon_laws.png"
    },
    {
      name: "notes",
      title: "Notebooks",
      icon: "bookmarks",
      route: "/notebooks",
      emit: null,
      photo: "img/icon_notebooks.png"
    },
    {
      name: "digests",
      title: "Digests",
      icon: "list-box",
      route: "/digests",
      emit: null,
      photo: "img/icon_digests.png"
    },
    // {
    //   name: "organize",
    //   title: "Organize",
    //   icon: "filing",
    //   route: "/organize",
    //   emit: null
    // },
    {
      name: "settings",
      title: "Settings",
      icon: "settings",
      route: "/settings",
      emit: null
    }
  ],
  routerStack: 0,
  text: null
};

let actions = {};

let getters = {};

let mutations = {
  setHeaderTitle(state, title) {
    state.header.title = title;
  },

  showBackButton(state, show) {
    state.showBackButton = show;
  },

  ShowClearHighlights(state, show) {
    state.showClearHighlights = show;
  },

  setMoreHeaderButtons(state, buttons) {
    state.moreHeaderButtons = buttons;
  },

  editMoreHeaderButtons(state, data) {
    if(state.moreHeaderButtons.web[data.idx] && state.moreHeaderButtons.mobile[data.idx]) {
      state.moreHeaderButtons.web[data.idx][data.field]= data.data;
      state.moreHeaderButtons.mobile[data.idx][data.field]= data.data;
      return;
    }
    return;
  },

  setLayout(state, layout) {
    state.layout = layout;
  },

  setTabs(state, tabs) {
    state.tabs = tabs;
  },

  setMenu(state, menu) {
    state.menu = menu;
  },

  setLastCaseQuery(state, q) {
    state.lastCaseQuery = q;
  },

  setLastLawQuery(state, q) {
    state.lastLawQuery = q;
  },

  setLastNotesQuery(state, q) {
    state.lastNotesQuery = q;
  },

  setLastDigestsQuery(state, q) {
    state.lastDigestsQuery = q;
  },

  setRouterStack(state, s) {
    state.routerStack = s;
  },

  setSpinner(state, s) {
    state.showSpinner = s;
  },

  setText(state, text) {
    state.text = text;
  },
};

export default {
  name: "ui",
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
